import {Controller, ControllerProps, useController} from "react-hook-form";

import {CheckboxGroup} from "@pg-design/checkbox-module";
import {ICheckboxGroupProps} from "@pg-design/checkbox-module/src/components/CheckboxGroup";

type IProps = Omit<ControllerProps, "render" | "value"> & Omit<ICheckboxGroupProps, "error">;

export const CheckBoxGroupControlled = (props: IProps) => {
    const {name, ...restProps} = props;
    const fieldController = useController({name});

    if (!fieldController) {
        throw new Error("CheckBoxGroupControlled is not wrapped in FormProvider, in this case, please wrap it with FormProvider");
    }

    return (
        <Controller
            name={name}
            render={({field}) => {
                return (
                    <CheckboxGroup
                        {...field}
                        {...restProps}
                        name={name}
                        onChange={(values) => {
                            field.onChange(values.map((element) => element.value));
                        }}
                    />
                );
            }}
        />
    );
};
import {Controller, ControllerProps, useController} from "react-hook-form";

import {CheckboxGroup} from "@pg-design/checkbox-module";
import {ICheckboxGroupProps} from "@pg-design/checkbox-module/src/components/CheckboxGroup";

type IProps = Omit<ControllerProps, "render" | "value"> & Omit<ICheckboxGroupProps, "error">;

export const CheckBoxGroupControlled = (props: IProps) => {
    const {name, ...restProps} = props;
    const fieldController = useController({name});

    if (!fieldController) {
        throw new Error("CheckBoxGroupControlled is not wrapped in FormProvider, in this case, please wrap it with FormProvider");
    }

    return (
        <Controller
            name={name}
            render={({field}) => {
                return (
                    <CheckboxGroup
                        {...field}
                        {...restProps}
                        name={name}
                        onChange={(values) => {
                            field.onChange(values.map((element) => element.value));
                        }}
                    />
                );
            }}
        />
    );
};
